import { render, staticRenderFns } from "./WhatsappEventsDetailsTable.vue?vue&type=template&id=496ca9f8&scoped=true&"
import script from "./WhatsappEventsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./WhatsappEventsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappEventsDetailsTable.vue?vue&type=style&index=0&id=496ca9f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ca9f8",
  null
  
)

export default component.exports